import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

const initialState = {
  authId: null,
  updatedAsha: null,
  viewSuccessBannerOnDetils: null
};

export const AuthAshaDetailsSlice = createSlice({
    name: "ashaAuthDetails",
    initialState,
    reducers: {
        userAuthId: (state, action: PayloadAction<any>) => {
            state.authId = action.payload;
          },
          updatedAsha: (state, action: PayloadAction<any>) => {
            state.updatedAsha = action?.payload;
          },
          viewSuccessBannerOnDetils: (state, action: PayloadAction<any>) => {
            state.viewSuccessBannerOnDetils = action.payload;
          }
    }
});

export const { userAuthId, updatedAsha, viewSuccessBannerOnDetils } = AuthAshaDetailsSlice.actions;
export const ashaAuthIdState = (state: RootState) => state.ashaAuthDetails;
export default AuthAshaDetailsSlice.reducer;
